import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Announcement {
  announcementId?: number;
  title?: string;
  message: string;
  createdBy?: string;
  createdAt?: string;
  active?: boolean;
  audience?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  private readonly baseUrl = `${environment.apiServiceBaseUrl}/hawdco/announcements`;

  constructor(private http: HttpClient) {}

  create(title: string, message: string, createdBy?: string, audience: string = 'web'): Observable<Announcement> {
    return this.http.post<Announcement>(this.baseUrl, { title, message, createdBy: createdBy || 'admin', audience });
  }

  getAll(): Observable<Announcement[]> {
    return this.http.get<Announcement[]>(this.baseUrl);
  }

  getPending(employeeId?: string | null, audience: string = 'web'): Observable<Announcement[]> {
    let params = new HttpParams();
    if (employeeId) { params = params.set('employeeId', employeeId); }
    if (audience) { params = params.set('audience', audience); }
    return this.http.get<Announcement[]>(`${this.baseUrl}/pending`, { params });
  }

  markViewed(id: number, employeeId: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/view`, { employeeId });
  }

  deactivate(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/deactivate`, {});
  }
}
